//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '../../../lib/util';
import expandRow from './table-expand.vue';

export default {
    name: 'my-signUpRecords',
    components: {expandRow},
    data() {
        const vm = this;
        return {
            columns: [
                {
                    type: 'expand',
                    width: 50,
                    render: (h, params) => {
                        return h(expandRow, {
                            props: {
                                row: params.row
                            }
                        });
                    }
                },
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '姓名',
                    key: 'name',
                    align: 'center'
                    // minWidth: 100
                },
                // {
                //     title: '性别',
                //     key: 'gender',
                //     render(h, params) {
                //         var str = '';
                //         if (params.row.gender === 1) {
                //             str = '男';
                //         } else if (params.row.gender === 2) {
                //             str = '女';
                //         } else {
                //             str = '其他';
                //         }
                //         return h('span', str);
                //     }
                // },
                {
                    title: '电话',
                    key: 'phoneNumber',
                    align: 'center'
                    // minWidth: 120
                },
                {
                    title: '报名时间',
                    key: 'signUpTimeStr',
                    align: 'center'
                },
                {
                    title: '已选日期',
                    key: 'activityDate',
                    align: 'center'
                },
                {
                    title: '已选时段',
                    key: 'timeSlot',
                    align: 'center'
                },
                {
                    title: '支付状态',
                    key: 'paymentStatus',
                    align: 'center',
                    render(h, params) {
                        const row = params.row;
                        var str = '';
                        if (params.row.paymentStatus === 0) {
                            str = '未缴费';
                        } else if (params.row.paymentStatus === 1) {
                            str = '已缴费';
                        } else {
                            str = '';
                        }
                        return h('span', str);
                    }
                },
                {
                    title: '是否签到',
                    key: 'isCheckIn',
                    align: 'center',
                    render(h, params) {
                        const row = params.row;
                        var str = '';
                        if (row.isCheckIn) {
                            str = '已签到';
                        } else {
                            str = '未签到';
                        }
                        return h('span', str);
                    }
                },
                {
                    title: '签到时间',
                    key: 'checkInTimeStr',
                    align: 'center'
                },
                {
                    title: '操作', align: 'center',
                    minWidth: 30,
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delSignUpRecord(params.row);
                                }
                            }
                        }, '删除');

                        // if (vm.hasPermission('Pages.ProjectManage.City.Edit')) {
                        actions.push(h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.signIn(params.row);
                                }
                            }
                        }, '签到'));
                        // }

                        if (vm.hasPermission('Pages.ActivityManage.Activity.Edit')) {
                            actions.push(del);
                        }

                        return h('div', actions);
                    }

                }
            ],
            list: [],
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            loading: false
        };
    },
    props: {
        activityId: {
            type: Number,
            required:
                true
        }
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getSignUpRecords();
        },
        pageSizeChange(size) {
            this.pageSize = size;
            this.getSignUpRecords();
        },
        getSignUpRecords() {
            this.loading = true;
            abp.ajax.post('/api/services/app/Activity/SearchSignUpRecords', {
                activityId: this.activityId,
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            }).then(res => {
                // this.list = [];
                this.totalCount = res.data.result.totalCount;
                this.list.push(...res.data.result.items);
            }).finally(() => {
                this.loading = false;
            });
        },
        onExport() {
            if (parseInt(this.activityId) > 0) {
                let url = util.ApiUrl + 'ServiceReport/SignUpRecordExport?activityId=' + this.activityId;
                window.open(url, '_blank');
            } else {
                return;
            }
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        },
        signIn(row) {
            this.$store.dispatch({
                type: 'activity/signIn',
                id: row.id
            }).then(res => {
                this.$Message.success('签到成功');
                this.getSignUpRecords();
            });
        },
        delSignUpRecord(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '报名记录吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    vm.$store.dispatch({
                        type: 'activity/delSignUpRecord',
                        id: row.id
                    }).then(() => {
                        vm.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        vm.getSignUpRecords();
                    });
                }
            });
        }
    },

    created() {
        this.getSignUpRecords();
    },
    watch: {
        activityId(o, n) {
            this.getSignUpRecords();
        }
    }
};
